<template>
  <app-board v-if="amReady">
    <h4 class="p-3 m-0">Customers</h4>
    <el-dialog :visible.sync="voipReportAnalysisStatisticRateDialog" title="" top="2vh" width="90%">
      <voipCustomerRates :customerDisplayName="customerData.display_name" :customerUserId="customerData.user_id"
                         :editLiveTrafficRate="editLiveTrafficRate" :showOnlyFixedRates="showOnlyFixedRates"
                         :showOnlyNewRates="showOnlyNewRates" :userRateStatus="userRateStatus"
                         :userUsingPrivateRate="userUsingPrivateRate"
                         v-if="voipReportAnalysisStatisticRateDialog"></voipCustomerRates>
    </el-dialog>

    <el-dialog :visible.sync="customerRatesBoardDialog" @close="reloadList" custom-class="bg-light-gray" title=""
               top="2vh"
               width="90%">
      <voipCustomerRates :customerDisplayName="customerData.display_name" :customerUserId="customerData.user_id"
                         :showOnlyFixedRates="showOnlyFixedRates" :showOnlyNewRates="showOnlyNewRates"
                         :userRateStatus="userRateStatus" :userUsingPrivateRate="userUsingPrivateRate"
                         v-if="customerRatesBoardDialog"></voipCustomerRates>
    </el-dialog>

    <el-dialog :visible.sync="divisionsPercentDialog" title="" top="2vh" width="90%">
      <divisionsPercentForm :afterUpdate="closeDivisionPercent" :defaultUserId="divisionsPercentUserId"
                            :editMode="false"
                            v-if="divisionsPercentDialog"></divisionsPercentForm>
    </el-dialog>

    <el-dialog :visible.sync="voipReportAnalysisStatisticDialog" title="" top="2vh" width="90%">
      <voipReportAnalysisStatistic :defaultFilterOptionValue="selectedCustomerUsername" defaultFilterValue="customer"
                                   v-if="voipReportAnalysisStatisticDialog"></voipReportAnalysisStatistic>
    </el-dialog>

    <div class="row pl-3 pr-3 m-0" style="height: 50px;">
      <div style="width: 250px;">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search country"></dg-text-field>
      </div>
      <div style="width: fit-content;margin-right: 20px">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
      <div class="pb-5 text-right">
        <downloadWorkingDestinationsButton></downloadWorkingDestinationsButton>
      </div>
      <div class="pb-5 ml-2 text-right">
        <el-button @click="refreshRatesAction" icon="el-icon-refresh" size="mini" type="primary">Refresh</el-button>
      </div>
    </div>
    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </app-board>
</template>

<script>

import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import hasLcrModule from './ag-grid/hasLcrModule'
import actionsCell from './ag-grid/ActionsCell'
import editOnFlyCell from "@/components/ag-grid-edit-on-fly-cell/View";
import divisionsPercentForm from "@/modules/voip_user_division_profit_percents/form/View";
// import usingPrivateRate from './ag-grid/PrivateRate'
// import openRates from './ag-grid/OpenRates'
// import downloadVOSRatesAgButton from './ag-grid/DownloadVOSRatesAgButton'

export default {
  components: {
    voipReportAnalysisStatistic: () => import('@/modules/voip-report-analysis-statistic/list/page/View'),
    divisionsPercentForm: divisionsPercentForm,
    pagination: () => import('@/components/pagination/View.vue'),
    voipCustomerRates: () => import('@/modules/voip-customer-rate/list/page/View'),
    downloadWorkingDestinationsButton: () => import('@/components/download-working-destinations/View')
  },
  data() {
    return {
      editLiveTrafficRate: false,
      voipReportAnalysisStatisticRateDialog: false,
      voipReportAnalysisStatisticDialog: false,
      selectedCustomerUsername: null,
      divisionsPercentUserId: null,
      divisionsPercentDialog: false,
      showOnlyFixedRates: false,
      showOnlyNewRates: false,
      userUsingPrivateRate: null,
      userRateStatus: null,
      customerRatesBoardDialog: false,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        rowClassRules: {
          'app-bg-gold-low-alfa': function (params) {
            return params.data.num_of_new_destinations_rates != '0';
          }
        },
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            width: 130,
            field: 'display_name',
            headerName: 'Customer',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          /*{
            width: 140,
            field: 'system_profit_percent',
            headerName: 'Percent',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(editOnFlyCell),
            cellRendererParams: {
              props: {
                inputWidth: '60px',
                valuePropertyName: 'system_profit_percent',
                saveAction: this.updateProfitPercent
              }
            }
            // below is just for reference
            cellRenderer: (params) => {
              return params.data.system_profit_percent  + '%';
            }
          },*/
          {
            width: 120,
            field: 'vos_recharge_link',
            headerName: 'VOS Link',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 120,
            field: 'vos_username',
            headerName: 'VOS User',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 130,
            field: 'account_manager_display_name',
            headerName: 'Account Manager',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 120,
            field: 'vos_password',
            headerName: 'VOS Password',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },/*
          {
            width: 80,
            field: 'using_private_rate',
            headerName: 'Has Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(usingPrivateRate),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },*/
          {
            width: 100,
            field: 'has_lcr',
            headerName: 'Has LCR',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(hasLcrModule),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            width: 100,
            field: 'current_rates_counter',
            headerName: 'Rates',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 100,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          /*{
            width: 80,
            headerName: "View Rates",
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(openRates),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            width: 80,
            headerName: 'VOS Rates',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(downloadVOSRatesAgButton),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }*/
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    refreshRatesAction(){
      this.refreshRates().then((response)=>{
        this.reloadList()
      })
    },
    refreshCustomerRates(params){
      
      this.refreshCustomerRatesApi({user_id : params.data.user_id}).then(response=>{
        this.reloadList()
      })
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    viewReportAnalysisStatisticRates(params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = -1
      this.customerData = data
      this.userRateStatus = '<span class="voip-call-test-status p-2">Live Traffic Rates</span>'
      this.userUsingPrivateRate = true
      this.editLiveTrafficRate = true
      this.voipReportAnalysisStatisticRateDialog = true
      // this.reportAnalysisStatisticViewMode = 'edit_live_traffic_rate'
    },
    viewReportAnalysisStatistic(params) {
      let data = params.data
      this.selectedCustomerUsername = data.username
      this.voipReportAnalysisStatisticDialog = true
    },
    ...$mapActions('voip-customer-rate-api', {
      syncRatesWithWorkingDestinations: 'syncRatesWithWorkingDestinations'
    }),
    updateProfitPercent(agGridParams, newValue, afterSave) {
      let data = {
        user_id: agGridParams.data.user_id,
        system_profit_percent: newValue
      }

      this.updateCustomerFields({data}).then(() => {
        afterSave()
      })
    },
    syncWithWorkingDestination(params) {
      this.syncRatesWithWorkingDestinations({data: {}, id: params.data.id})
      this.reloadList()
    },
    reloadList() {
      this.getEntityListData(this.currentPage)
    },
    openFixedRatesOnly(params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = true
      this.rowToEdit = params.rowIndex
      this.customerData = data
      this.userRateStatus = (this.showOnlyFixedRates) ? '<span class="app-bg-gold-low-alfa pending p-2">Only Fixed Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.customerRatesBoardDialog = true
    },
    closeDivisionPercent() {
      this.divisionsPercentDialog = false
    },
    openDivisionsPercent(params) {
      let data = params.data
      this.divisionsPercentUserId = data.user_id
      this.divisionsPercentDialog = true
    },
    openCustomerRatesBoard(params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = params.rowIndex
      this.customerData = data
      this.userRateStatus = (this.showOnlyNewRates) ? '<span class="app-bg-gold-low-alfa pending p-2">New Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.customerRatesBoardDialog = true
    },
    openCustomerNewRatesBoard(params) {
      let data = params.data
      this.showOnlyNewRates = true
      this.showOnlyFixedRates = false
      this.rowToEdit = params.rowIndex
      this.customerData = data
      this.userRateStatus = (this.showOnlyNewRates) ? '<span class="app-bg-gold-low-alfa pending p-2">New Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.customerRatesBoardDialog = true
    },
    downloadVOSRate(params) {
      this.downloadVosRateAction({id: params.data.id})
    },
    ...$mapActions('user-customer-features-api', {
      updateCustomerFields: 'update'
    }),
    setUserHasLcrModule(params) {
      let data = {
        user_id: params.userId,
        modules: [
          'voip-lcr-menu',
          'voip-lcr-top-destinations'
        ]
      }
      if (params.value) {
        this.giveUserModules({data})
      } else {
        this.removeUserModules({data})
      }
    },
    ...$mapActions('user-api', {
      giveUserModules: 'giveUserModules',
      removeUserModules: 'removeUserModules'
    }),
    setUserUsingPrivateRate(params) {
      let apiData = params.apiData
      let rowData = params.rowData

      let data = {
        using_private_rate: (apiData.value == true) ? 1 : 0,
        user_id: apiData.userId
      }

      /*this.agGrid.rowData[this.rowToEdit] = rowData;
      this.refreshGrid();*/

      this.updateCustomerFields({data})
    },
    getEntityListData(page) {
      
     
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    ...$mapActions('voip-customer-api', {
      getEntityList: 'list',
      downloadVosRateAction: 'downloadVosRate',
      refreshRates: 'refreshRates',
      refreshCustomerRatesApi: 'refreshCustomerRates',
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->voip-customer->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'module->voip-customer->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
